export function parseVideoId() {
  const getVideoId = (url: string | null | undefined, type: string): string | null => {
    if (!url || typeof url !== 'string') return null;
    try {
      if (type === 'Youtube') {
        const regex = /(?:v=|\/)([a-zA-Z0-9_-]{11})(?:[&?]|$)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      } else if (type === 'Vimeo') {
        const regex = /(?:^|\/)(\d+)(?:[/?#]|$)/;
        const match = url.match(regex);
        return match ? match[1] : null;
      } else {
        console.error(`Unsupported type: ${type}`);
        return null;
      }
    } catch (error) {
      console.error(`Error extracting video ID for type "${type}":`, error);
      return null;
    }
  };

  return { getVideoId };
}
